import { InternalId } from '@edgebox/data-definition-kit';
import { ClientProjectEntity } from '@edgebox/sync-core-rest-client';
import React from 'react';
import { ISyncCoreApiComponentState, SyncCoreApiComponent } from '../services/SyncCoreApiComponent';

interface IProps {
  entityId?: InternalId;
  children: (entity?: ClientProjectEntity) => React.ReactNode;
}

interface IState extends ISyncCoreApiComponentState {
  entity?: ClientProjectEntity;
  loaded?: boolean;
}

export class WithProject extends SyncCoreApiComponent<IProps, IState> {
  async load() {
    try {
      if (this.props.entityId) {
        const entity = await this.api.syndication.projects.item(this.props.entityId);
        return {
          loaded: true,
          entity,
        };
      }
    } catch (e) {}
    return {
      loaded: true,
    };
  }

  render() {
    const { children } = this.props;
    const { loaded, entity } = this.state;

    if (!loaded) {
      return this.renderRequest();
    }

    return children(entity);
  }
}
